import { inputValueProblem, type InputFormat } from "@cd/core";

/**
 * Dashboard inputs as their boxes show them. A percent input stores a fraction: the box shows 3 and
 * the value is 0.03.
 */

/** The text a box shows for a stored value. */
export function toBoxText(format: InputFormat, value: number): string {
  const shown = format === "percent" ? Math.round(value * 100 * 1e6) / 1e6 : value;
  return String(shown);
}

/** The stored value for what someone typed, or an error to show under the box. */
export function fromBoxText(format: InputFormat, text: string): { value: number } | { error: string } {
  const cleaned = text.replace(/[\s,$%]/g, "");
  if (!/^-?(\d+\.?\d*|\.\d+)$/.test(cleaned)) return { error: "Enter a number" };
  const n = Number(cleaned);
  const value = format === "percent" ? Math.round(n * 1e6) / 1e8 : n;
  const bad = inputValueProblem(format, value);
  return bad ? { error: bad[0]!.toUpperCase() + bad.slice(1) } : { value };
}

/** The values the widgets get: the saved ones, with any the viewer is trying instead. */
export function effectiveInputs(saved: { id: string; saved: number }[], tried: Record<string, number> = {}): Record<string, number> {
  return Object.fromEntries(saved.map((i) => [i.id, tried[i.id] ?? i.saved]));
}
